// extracted by mini-css-extract-plugin
export default {"notfound":"notFound_notfound__GXSfs"};